import React from "react";
import styled from "styled-components";
import { CopyButton } from "../ClickToCopy";
import { CopyButtonProps } from "../ClickToCopy/CopyButton";
import { TagContainer, TagText, TagIcon, tagActionButtonStyles } from "./BaseStyles";
import { BaseTagProps } from "./Tag";

type CopyableTagProps = BaseTagProps &
  Omit<CopyButtonProps, "copy"> & {
    copy?: string;
    /**
     * By default the "product-tag" icon is displayed. Set to `false` to hide the icon.
     */
    icon?: false | string;
  };

const TagCopyButton = styled(CopyButton)`
  ${tagActionButtonStyles()}
`;

export const CopyableTag: React.FC<CopyableTagProps> = ({ copy, tooltipText, ariaLabel, maxWidth, children, icon = "product-tag" }) => {
  return (
    <TagContainer $hasActionButton style={{ maxWidth }}>
      {icon && <TagIcon icon={icon} />}
      <TagText>{children}</TagText>
      <TagCopyButton copy={copy ?? children} tooltipText={tooltipText || "Copy tag"} ariaLabel={ariaLabel} />
    </TagContainer>
  );
};
